export default function getNextWeekDates() {
  const crr = new Date();
  const datumOd = new Date();
  let dayOfWeek = crr.getDay();
  if (dayOfWeek == 0) {
    dayOfWeek = 7;
  }

  datumOd.setDate(datumOd.getDate() + (8 - dayOfWeek));
  datumOd.setHours(0, 0, 0, 0);
  const datumDo = new Date(datumOd);
  datumDo.setDate(datumOd.getDate() + 6);
  datumDo.setHours(0, 0, 0, 0);

  return { datumOd, datumDo };
}
